<template>
  <div>
    <div class="mobile_footer_fixed" ref="refCartMobile">
      <v-slide-group>
        <v-slide-item
          v-for="(menu, idx) in menu_items"
          :key="$uuid.v1()"
          v-slot="{ active, toggle }"
          v-if="
            menu.action != 'live' ||
            (menu.action == 'live' && getSettings.enableLive)
          "
        >
          <div
            class="menu_footer_fixed_box"
            @click="actionDispatcher(menu.action)"
          >
            <div class="icon">
              <template v-if="menu.action == 'live'">
                <svg
                  version="1.1"
                  id="Livello_1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  viewBox="0 0 120 120"
                  style="enable-background: new 0 0 120 120"
                  xml:space="preserve"
                >
                  <g>
                    <path
                      d="M67.9,23.9v-4.2l10,0v-0.9c0-7.6-6-16.7-13.6-16.7h-10c-7.6,0-14.3,9.1-14.3,16.7V20h12v3.8c-24,3.9-40.9,23.3-40.9,46.7
		c0,26.2,20.5,47.5,46.7,47.5c26.2,0,48.4-21.2,48.4-47.5C106.1,47.2,89.9,27.8,67.9,23.9z M63.9,106.7v-5.2c0-2-2-3.7-4-3.7
		c-2,0-4,1.7-4,3.7v5.2C39.9,105,22.5,94,20.7,74H26c2,0,3.7-2,3.7-4c0-2-1.6-4-3.7-4h-5.2c1.9-18,17.4-32.3,36.2-32.3
		c20.1,0,38,16.5,38,36.6C95,89.1,81.9,104.9,63.9,106.7z"
                    />
                    <path
                      d="M58.3,39c-0.1,0-0.1,0-0.2,0v33.9h34.4C92.4,54.2,77.1,39,58.3,39L58.3,39z"
                    />
                    <path
                      d="M107.9,32.3l-7.7-7.7c-0.7-0.7-1.6-1.1-2.6-1.1c-1,0-1.9,0.4-2.6,1.1l-6.2,6.2l12.9,12.9l6.2-6.2
		C109.3,36,109.3,33.7,107.9,32.3L107.9,32.3z"
                    />
                  </g>
                </svg>
              </template>
              <template v-else-if="menu.action == 'homeAndReset'">
                <svg
                  version="1.1"
                  id="Livello_1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  viewBox="0 0 120 120"
                  style="enable-background: new 0 0 120 120"
                  xml:space="preserve"
                >
                  <path
                    class="st0"
                    d="M115.95,55.64c-0.25-2.37-1.43-4.49-3.3-5.97L66.88,13.72c-4.05-3.18-9.71-3.18-13.76,0L7.35,49.67
	c-1.88,1.48-3.05,3.6-3.3,5.97c-0.25,2.38,0.45,4.69,1.98,6.53c3.01,3.62,8.51,4.16,12.26,1.21l2.19-1.72v37.07
	c0,5.49,4.46,9.95,9.95,9.95h15.68c1.27,0,2.3-1.03,2.3-2.3V92.33c0-6.29,5.11-11.4,11.4-11.4s11.4,5.11,11.4,11.4v14.04
	c0,1.27,1.03,2.3,2.3,2.3h16.06c5.49,0,9.95-4.46,9.95-9.95V61.65l2.19,1.72c3.76,2.95,9.26,2.41,12.27-1.21
	C115.5,60.33,116.2,58.01,115.95,55.64"
                  />
                </svg>
              </template>
              <template v-else-if="menu.action == 'menu'">
                <svg
                  version="1.1"
                  id="Livello_1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  viewBox="0 0 100 100"
                  style="enable-background: new 0 0 100 100"
                  xml:space="preserve"
                >
                  <g>
                    <g>
                      <path
                        class="st0"
                        d="M95.7,88.89H72.41v-4.14c0-10.57,8.57-19.15,19.15-19.15h4.14V88.89z"
                      />
                      <g>
                        <path
                          class="st0"
                          d="M58.85,74.78H11.51c-3.98,0-7.21,3.07-7.21,7.05c0,3.98,3.23,7.05,7.21,7.05h47.34
				c3.98,0,7.21-3.07,7.21-7.05C66.09,77.85,62.83,74.78,58.85,74.78L58.85,74.78z M90.26,55.59"
                        />
                        <path
                          class="st0"
                          d="M88.48,11.11H11.51c-3.98,0-7.21,3.07-7.21,7.05c0,3.98,3.23,7.05,7.21,7.05h76.97
				c3.98,0,7.21-3.07,7.21-7.05C95.73,14.18,92.47,11.11,88.48,11.11L88.48,11.11z M90.26,11.11"
                        />
                        <path
                          class="st0"
                          d="M88.48,42.31H11.51c-3.98,0-7.21,3.64-7.21,7.62c0,3.99,3.23,7.62,7.21,7.62h76.97
				c3.98,0,7.21-3.64,7.21-7.62C95.7,45.94,92.47,42.31,88.48,42.31L88.48,42.31z M90.26,32.85"
                        />
                      </g>
                    </g>
                    <rect y="0" class="st1" width="100" height="100" />
                  </g>
                </svg>
              </template>
              <template v-else-if="menu.action == 'cart'">
                <v-badge
                  :content="getBet.odds.length"
                  :value="getBet.odds.length"
                  overlap
                  class="text-black"
                >
                  <svg
                    version="1.1"
                    id="Livello_1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    viewBox="0 0 120 120"
                    style="enable-background: new 0 0 120 120"
                    xml:space="preserve"
                  >
                    <g>
                      <path
                        d="M106.2,4H13.8c-2.2,0-4,1.8-4,4v104c0,1.7,1,3.1,2.6,3.7c0.5,0.2,1,0.3,1.5,0.3c1.1,0,2.2-0.5,2.9-1.3l12-13.1
		c0.2-0.2,0.4-0.2,0.6-0.2c0.1,0,0.4,0,0.6,0.2l11.8,12.9c0.8,0.8,1.8,1.3,3,1.3c1.1,0,2.2-0.5,3-1.3l11.8-12.9
		c0.2-0.2,0.4-0.2,0.6-0.2s0.4,0,0.6,0.2l11.8,12.9c0.8,0.8,1.8,1.3,3,1.3c0,0,0,0,0,0c1.1,0,2.2-0.5,3-1.3l11.8-12.9
		c0.2-0.2,0.4-0.2,0.6-0.2s0.4,0,0.6,0.2l12,13.1c1.1,1.2,2.9,1.6,4.4,1c1.6-0.6,2.6-2.1,2.6-3.7V8C110.2,5.8,108.4,4,106.2,4z
		 M101.7,13.2v85.4c0,0.4-0.3,0.6-0.5,0.7c-0.1,0.1-0.5,0.1-0.8-0.2l-6.8-7.4c-0.8-0.8-1.8-1.3-3-1.3s-2.2,0.5-3,1.3l-11.8,12.9
		c-0.2,0.2-0.4,0.2-0.6,0.2h0c-0.1,0-0.4,0-0.6-0.2L63,91.7c-0.8-0.8-1.8-1.3-3-1.3h0c-1.1,0-2.2,0.5-3,1.3l-11.8,12.9
		c-0.2,0.2-0.4,0.2-0.6,0.2c-0.1,0-0.4,0-0.6-0.2L32.3,91.7c-0.8-0.8-1.8-1.3-3-1.3c-1.1,0-2.2,0.5-3,1.3l-6.8,7.4
		c-0.3,0.3-0.6,0.3-0.8,0.2c-0.1-0.1-0.5-0.2-0.5-0.7V13.2c0-0.4,0.3-0.8,0.8-0.8H101C101.4,12.5,101.7,12.8,101.7,13.2z"
                      />
                      <path
                        d="M94,19.6H26.1c-2.3,0-4.2,1.9-4.2,4.2s1.9,4.2,4.2,4.2H94c2.3,0,4.2-1.9,4.2-4.2S96.3,19.6,94,19.6z"
                      />
                      <path
                        d="M94,32.1H26.1c-2.3,0-4.2,1.9-4.2,4.2s1.9,4.2,4.2,4.2H94c2.3,0,4.2-1.9,4.2-4.2S96.3,32.1,94,32.1z"
                      />
                      <path
                        d="M94,44.6H26.1c-2.3,0-4.2,1.9-4.2,4.2s1.9,4.2,4.2,4.2H94c2.3,0,4.2-1.9,4.2-4.2S96.3,44.6,94,44.6z"
                      />
                    </g>
                  </svg>
                </v-badge>
              </template>
              <template v-else>
                <v-icon dense>
                  {{ menu.icon }}
                </v-icon>
              </template>
              <div
                class="text"
                :class="isSelected(menu.action) ? 'selected' : ''"
              >
                {{ $t(menu.text) }}
              </div>
            </div>
          </div>
        </v-slide-item>
      </v-slide-group>
    </div>

    <v-dialog
      v-model="drawer"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      class="revengeBetConsole"
    >
      <v-row class="no-margin cart-mobile">
        <v-col cols="12" class="text-right pt-2 pb-2 d-flex-center-all">
          <span class="title-box text-uppercase pl-2">{{ $t('menu') }}</span>
          <v-spacer></v-spacer>
          <v-icon
            @click.stop="
              menuHandler()
              selected = ''
            "
            >mdi-close</v-icon
          >
        </v-col>
        <v-divider></v-divider>
        <v-col cols="12" class="left-module-mobile">
          <LeftModule></LeftModule>
        </v-col>
      </v-row>
    </v-dialog>
    <!-- /cart -->

    <!-- cart -->
    <v-dialog
      v-model="drawer_cart"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      class="revengeBetConsole"
    >
      <v-row class="no-margin cart-mobile mobileFooterFixedPad">
        <v-col cols="12" class="text-right pt-2 pb-2 align-center">
          <v-spacer></v-spacer>
          <svg
            @click.stop="
              cartHandler()
              selected = ''
            "
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.7699 1.33324L6.99991 5.11324L3.22991 1.33324C2.9784 1.08173 2.63727 0.94043 2.28158 0.94043C1.92588 0.94043 1.58476 1.08173 1.33324 1.33324C1.08173 1.58476 0.94043 1.92588 0.94043 2.28158C0.94043 2.63727 1.08173 2.9784 1.33324 3.22991L5.11324 6.99991L1.33324 10.7699C1.08173 11.0214 0.94043 11.3625 0.94043 11.7182C0.94043 12.0739 1.08173 12.4151 1.33324 12.6666C1.58476 12.9181 1.92588 13.0594 2.28158 13.0594C2.63727 13.0594 2.9784 12.9181 3.22991 12.6666L6.99991 8.88658L10.7699 12.6666C11.0214 12.9181 11.3625 13.0594 11.7182 13.0594C12.0739 13.0594 12.4151 12.9181 12.6666 12.6666C12.9181 12.4151 13.0594 12.0739 13.0594 11.7182C13.0594 11.3625 12.9181 11.0214 12.6666 10.7699L8.88658 6.99991L12.6666 3.22991C12.7911 3.10537 12.8899 2.95753 12.9573 2.79481C13.0247 2.63209 13.0594 2.4577 13.0594 2.28158C13.0594 2.10545 13.0247 1.93106 12.9573 1.76834C12.8899 1.60563 12.7911 1.45778 12.6666 1.33324C12.542 1.20871 12.3942 1.10992 12.2315 1.04252C12.0688 0.97512 11.8944 0.94043 11.7182 0.94043C11.3625 0.94043 11.0214 1.08173 10.7699 1.33324Z"
            />
          </svg>
          <!--                    <v-icon @click.stop="cartHandler(); selected = ''">mdi-close</v-icon>-->
        </v-col>
        <v-col cols="12" sm="12" md="12" class="bordered-element">
          <RightModule></RightModule>
        </v-col>
      </v-row>
    </v-dialog>
    <!-- /cart -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import LeftModule from '@/components/Left.vue'
import Search from '@/components/generic/Search'
import CenterModule from '@/components/Center'
import RightModule from '@/components/Right'

export default {
  name: 'MobileFooterFixed',
  data() {
    return {
      selected: 'home',
      drawer: false,
      drawer_cart: false,
      count_live_total: '',
      dialogSearch: false,
      menu_items: [
        { text: this.$t('menu'), icon: 'mdi-menu', action: 'menu' },
        { text: this.$t('home'), icon: 'mdi-home', action: 'homeAndReset' },
        { text: this.$t('live'), icon: 'mdi-alarm-plus', action: 'live' },
        { text: this.$t('betSlip'), icon: 'mdi-file-document', action: 'cart' },
      ],
      lastScroll: 0,
      viewHeader: true,
      openlivesection:
        window.openlivesection != null
          ? window.openlivesection === 'true' || window.openlivesection === true
            ? true
            : false
          : false,
      openTree:
        window.openTree != null
          ? window.openTree === 'true' || window.openTree === true
            ? true
            : false
          : false,
    }
  },
  components: {
    Search,
    LeftModule,
    CenterModule,
    RightModule,
  },
  computed: {
    ...mapGetters({
      getAuthenticated: 'user/getAuthenticated',
      getId: 'user/getId',
      getLogin: 'user/getLogin',
      getBet: 'cart/getBet',
      getCountLive: 'odds/getCountLive',
      getLiveMode: 'odds/getLiveMode',
      getSettings: 'cart/getSettings',
      getGameConsole: 'settings/getGameConsole',
      getMobileCartOpen: 'cart/getMobileCartOpen',
      getProgramOpen: 'settings/getProgramOpen',
    }),
  },
  methods: {
    ...mapActions({
      setLiveMode: 'odds/setLiveMode',
      setMobileCartOpen: 'cart/setMobileCartOpen',
      setProgramOpen: 'settings/setProgramOpen',
      closePrematchEventsCards: 'odds/closePrematchEventsCards',
    }),

    actionDispatcher(action) {
      this.selected = action
      switch (action) {
        case 'menu':
          this.menuHandler()
          break
        case 'live':
          this.liveHandler()
          break
        case 'search':
          this.searchHandler()
          break
        case 'cart':
          this.cartHandler()
          break
        case 'home':
          this.homeHandler()
          break
        case 'homeAndReset':
          this.homeHandlerAndResetState()
          break
      }
    },

    menuHandler() {
      this.drawer = !this.drawer
      this.setProgramOpen(this.drawer)
    },

    liveHandler() {
      this.setLiveMode({ mode: 'detail' })
      this.selected = 'live'
      this.setMenu(false)
    },

    searchHandler() {
      this.dialogSearch = true
    },

    cartHandler() {
      try {
        // console.log("🔥 Before scroll: ", window.scrollY);

        window.scrollTo({ top: 0, behavior: 'smooth' }) // iframe scroll

        setTimeout(() => {
          // console.log("📌 After the scrollTo(): ", window.scrollY);

          // if not 0 scroll again
          if (window.scrollY > 0) {
            window.scrollTo(0, 0)
          }
        }, 500)

        // 2️⃣ Scroll also the parent if we are from iframe
        if (window.parent && window.parent !== window) {
          try {
            // console.log("🎯 Scrollo anche il parent iframe.");
            window.parent.scrollTo({ top: 0, behavior: 'smooth' })

            setTimeout(() => {
              // console.log("🛠 Posizione parent dopo scroll:", window.parent.scrollY);
              if (window.parent.scrollY > 0) {
                //console.log("⚠️ Parent not yet at 0, scroll again...");
                window.parent.scrollTo(0, 0)
              }
            }, 500)
          } catch (error) {
            console.warn('❌ Impossibile scroll the parent:', error)
          }
        }

        // 3️⃣Check html and body
        document.documentElement.scrollTop = 0
        document.body.scrollTop = 0

        // setTimeout(() => {
        //     console.log("📌 Dopo HTML/BODY scroll:", document.documentElement.scrollTop, document.body.scrollTop);
        // }, 500);
      } catch (error) {
        console.warn('❌ Generic error while scrolling:', error)
      }

      // 4️⃣ Open the cart
      this.drawer_cart = !this.drawer_cart
      this.setMobileCartOpen(this.drawer_cart)
    },

    homeHandler() {
      this.setLiveMode({ mode: 'preview' })
      this.selected = 'home'
      this.$root.$emit('homeButtonMobilePressed')
    },

    homeHandlerAndResetState() {
      if (localStorage.getItem('event-detail')) {
        localStorage.removeItem('event-detail')
      }
      if (localStorage.getItem('preview-tournament-visited')) {
        localStorage.removeItem('preview-tournament-visited')
      }

      this.homeHandler()
      this.closePrematchEventsCards()
      this.setMenu(false)
    },

    isSelected(action) {
      if (this.selected == 'action') {
        return true
      } else if (action == 'home' && this.getLiveMode == 'preview') {
        return true
      } else if (action == 'live' && this.getLiveMode == 'detail') {
        return true
      } else {
        return false
      }
    },
    setMenu(status) {
      this.drawer = status
      this.setProgramOpen(this.drawer)
    },
  },

  mounted() {
    const vm = this
    this.$root.$on('close_sidebar_left', function (value) {
      if (value) {
        vm.menuHandler()
        vm.selected = ''
      }
    })

    this.$root.$on('close_search', function (value) {
      if (value) {
        vm.dialogSearch = !vm.dialogSearch
        vm.selected = ''
      }
    })

    this.$root.$on('cart_handling', function () {
      vm.cartHandler()
    })

    this.$root.$on('open_sidebar_left', function () {
      if (vm.getLiveMode == 'detail') {
        vm.homeHandler()
      }

      vm.menuHandler()
    })

    this.$root.$on('set_live_mode_detail', function () {
      vm.liveHandler()
    })

    this.$root.$on('set_live_mode_preview', function () {
      vm.homeHandler()
    })

    this.$root.$on('set_live_mode_preview_and_reset_state', function () {
      vm.homeHandlerAndResetState()
    })

    if (this.openlivesection === true) {
      this.liveHandler()
    }

    if (this.openTree === true) {
      this.menuHandler()
    }
  },

  beforeDestroy() {
    this.$root.$off('close_sidebar_left', () => {})

    this.$root.$off('close_search', () => {})

    this.$root.$off('cart_handling', () => {})

    this.$root.$off('open_sidebar_left', () => {})

    this.$root.$off('set_live_mode_detail', () => {})

    this.$root.$off('set_live_mode_preview', () => {})

    this.$root.$off('set_live_mode_preview_and_reset_state', () => {})
  },
}
</script>
